// Declare action names as constants with uppercase string
/* eslint-disable no-throw-literal */
import ApiService from '../services/ApiService';
export const SAS_BEGIN = 'SAS_BEGIN';
export const SAS_SUCCESS = 'SAS_SUCCESS';
export const SAS_FAILURE = 'SAS_FAILURE';

// Thunk: this is a special type of action that can dispatch other actions
export function fetchSasToken() {
    return async dispatch => {
        dispatch(sasBegin());
        await ApiService.getSas()
            .then(
                result => {
                    dispatch(sasSuccess(result));
                },
                error => {
                    dispatch(sasFailure(error));
                    // throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const sasBegin = () => ({
    type: SAS_BEGIN
});
export const sasSuccess = data => ({
    type: SAS_SUCCESS,
    payload: { data }
});
export const sasFailure = error => ({
    type: SAS_FAILURE,
    payload: { error }
});